export const projects = [
  {
    name: 'Rejectory',
    tagline: 'Job application tracker',
    description:
      'Keep track of every job application: where you applied, what stage you are at, and what comes next. A calm, keyboard-friendly tracker that stores your data your way.',
    tech: ['Vue', 'Pinia', 'Firebase'],
    url: 'https://rejectory.com',
    logo: '/projects/rejectory.svg',
    accent: '#eb7100',
    titleKind: 'wordmark',
  },
  {
    name: 'Flipsy',
    tagline: 'In-browser image converter',
    description:
      'A fast, browser-based image conversion tool. Convert between formats instantly, with no uploads and nothing to install. Everything runs locally in your tab.',
    tech: ['React', 'TypeScript', 'Firebase'],
    url: 'https://flipsy.me',
    logo: '/projects/flipsy.svg',
    accent: '#01afab',
    titleKind: 'logo',
  },
  {
    name: 'Livery',
    tagline: 'ML liver-weight prediction',
    description:
      'A web app that predicts liver weight from preoperative clinical measurements, powered by an in-browser TensorFlow.js model trained on real surgical data.',
    tech: ['Vue', 'TensorFlow.js', 'Firebase'],
    url: 'https://livery.one',
    logo: '/projects/livery.svg',
    accent: '#01afab',
    titleKind: 'dot',
    titleTail: 'one',
  },
  {
    name: 'Portfolio',
    tagline: 'This very website',
    description:
      'My portfolio: a single-page introduction built from scratch with Vue 3, hand-tuned animations, organic illustrations, and a tidy design-token setup.',
    tech: ['Vue', 'Tailwind', 'SCSS'],
    url: 'https://github.com/kdraslan',
    logo: '/projects/portfolio.svg',
    accent: '#af0151',
    titleKind: 'gradient',
  },
];
